import { createSlice } from '@reduxjs/toolkit';
import getReducersLayout from '../utils/getReducersLayout';

interface IUISlice {
  windowWidth: number;
}

const initialState: IUISlice = {
  windowWidth: window.innerWidth,
};

const uiSlice = createSlice({
  name: 'UI',
  initialState,
  reducers: {
    ...getReducersLayout<IUISlice>(initialState),
  },
});

export const { resetData, setData } = uiSlice.actions;
export default uiSlice;
